import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { EditPageButtonProps } from "./edit-page-button.types";

export const EditPageButton = ({ onEditPage }: EditPageButtonProps) => {
	return <Button icon={EpicIcons.PENCIL} onClick={onEditPage} />;
};
